import Vue from 'vue'

Vue.component('vue-gallery', {
  template: '#vue-gallery-template',
  props: ['items'],
  data() {
    return {
      currentImage: this.$props.items[0],
      thumbnails: this.createThumbnails(this.$props.items),
    }
  },
  methods: {
    createThumbnails,
    setActiveElement,
  },
  mounted() {
    this.setActiveElement(0)
  },
})

function createThumbnails(items) {
  return items.map(item => ({
    ...item,
    active: false,
  }))
}

function setActiveElement(index) {
  this.currentImage = this.thumbnails[index]

  this.thumbnails = this.thumbnails.map((item, itemIndex) => ({
    ...item,
    active: itemIndex === index,
  }))
}
